// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"Info_wrapper__29HT6","icon":"Info_icon__ivNC6","text":"Info_text__75psE"};